import { Outlet, useLocation } from 'react-router-dom';
import LeafNav from './LeafNav';
import Footer from '../Footer';
import BalanceBadge from '../BalanceBadge';
import NotificationBadge from '../NotificationBadge';

/**
 * AppShell — layout wrapper for all authenticated routes.
 *
 * Renders a small floating leaf trigger (LeafNav) that opens the
 * navigation drawer, a quiet cherry-balance badge in the top-right,
 * the routed page content, and a calm footer at the end of the
 * scrollable content. No top bar, so page content uses the full height.
 *
 * The footer is skipped on fullscreen flows (book handover, chat) where
 * the page owns the viewport edge to edge.
 */
const FULLSCREEN_PREFIXES = ['/handover', '/chat'];

export default function AppShell() {
  const location = useLocation();
  const showFooter = !FULLSCREEN_PREFIXES.some((p) => location.pathname.startsWith(p));
  return (
    <div className="flex min-h-screen flex-col bg-parchment">
      <LeafNav />
      <BalanceBadge />
      <NotificationBadge />
      <main className="flex-1">
        <Outlet />
      </main>
      {showFooter && <Footer />}
    </div>
  );
}
